export const resumeColumns = ({ isMonthly = false }) => {
  const type = isMonthly ? "mes" : "dia";

  return [
    {
      title: "Llamadas",
      children: [
        {
          title: "Llamadas recibidas",
          dataIndex: type === "mes" ? `recibida_mes` : `recibidas_dia`,
          key: `recibida_${type}`,
        },
        {
          title: "Llamadas atendidas",
          dataIndex: `atendidas_${type}`,
          key: `atendidas_${type}`,
        },
        {
          dataIndex: `atendidas30_${type}`,
          key: `atendidas30_${type}`,
          slots: { title: "nsCallsTitle" },
        },
        {
          title: "Llamadas abandonadas",
          dataIndex: `abandonadas_${type}`,
          key: `abandonadas_${type}`,
        },
      ],
    },
    {
      title: "% Niveles",
      children: [
        {
          title: "% Nivel atendidas",
          dataIndex: `nivel_atencion_${type}`,
          key: `nivel_atencion_${type}`,
          slots: { customRender: "percentLevel" },
        },
        {
          title: "% Nivel de servicio",
          dataIndex: `nivel_servicio_${type}`,
          key: `nivel_servicio_${type}`,
          slots: { customRender: "percentLevel" },
        },
        {
          title: "% Nivel de abandono",
          dataIndex: `nivel_abandono_${type}`,
          key: `nivel_abandono_${type}`,
          slots: { customRender: "percentLevel" },
        },
      ],
    },
    {
      title: "Tiempo (seg)",
      children: [
        {
          dataIndex: `tmo_${type}`,
          key: `tmo_${type}`,
          slots: { title: "tmoTitle" },
        },
        {
          dataIndex: `tme_${type}`,
          key: `tme_${type}`,
          slots: { title: "tmeTitle" },
        },
        {
          dataIndex: `tiempo_hablado_${type}`,
          key: `tiempo_hablado_${type}`,
          slots: { title: "thTitle" },
        },
        {
          dataIndex: `tiempo_tipificado_${type}`,
          key: `tiempo_tipificado_${type}`,
          slots: { title: "ttTitle" },
        },
      ],
    },
  ];
};
